module.exports = __webpack_public_path__ + "static/media/promo-katalog.4a285dd3.jpg";